import React, { useEffect } from "react";
import { KeylineGrid, KeylineGridItem } from "web/react/components/keyline-grid";
import {
    FeedProductCard,
    getProductIdsForCriteo,
} from "web/react/components/LEGACY-feed-grid/feed-grid";
import analytics from "web/script/analytics/analytics";
import { ProductFeedSerializer } from "web/types/serializers";
import styles from "./discovery-feed-grid.module.css";

interface FeedImageCardProps {
    title: string;
    imageUrl: string;
}

function FeedImageCard({ title, imageUrl }: FeedImageCardProps): JSX.Element {
    return (
        <div className={styles.imageCardContainer}>
            <img src={imageUrl} alt={title} />
        </div>
    );
}

interface DiscoveryFeedGridProps {
    feedItems:
        | ProductFeedSerializer["feed_items"]
        | { item_type: string; image_card_url: string }[];
    title: string;
    feedType: string;
}

export function DiscoveryFeedGrid({
    feedItems,
    title,
    feedType,
}: DiscoveryFeedGridProps): JSX.Element {
    const products: ProductFeedSerializer["feed_items"] = [];
    feedItems.map((item) => {
        if (item.item_type === "productCard") {
            products.push(item);
        }
    });
    const criteoIds = getProductIdsForCriteo(products);
    useEffect(() => {
        analytics.tagEvent(analytics.TAG_NETWORKS.CRITEO, "criteo_product_ids", {
            ids: criteoIds,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(criteoIds)]);

    return (
        <KeylineGrid gridClassName={styles.discovery}>
            {feedItems.map((feedItem, i) => {
                if (feedItem.item_type === "productCard") {
                    return (
                        <KeylineGridItem key={i}>
                            <FeedProductCard product={feedItem.product_card} feedType={feedType} />
                        </KeylineGridItem>
                    );
                } else if (feedItem.image_card_url) {
                    return (
                        <KeylineGridItem key={i} doubleColumn={true}>
                            <FeedImageCard
                                title={`${title}-${i}`}
                                imageUrl={feedItem.image_card_url}
                            />
                        </KeylineGridItem>
                    );
                }
            })}
        </KeylineGrid>
    );
}
